export default __webpack_public_path__ + "static/media/heat-3.358bcd8f.png";